import React from 'react';
import { Box, SectionHeading, Spinner, Stack } from '@99designs/emu';
import { PackageCard } from '@99designs/spa-common';
import { useForm } from '../../ObservableForm';
import { SquarespacePackageChoiceFieldFragment } from './SquarespacePackageChoiceField.generated';
import { useWebPackageConfig } from './useWebPackageConfig';

export type Props = SquarespacePackageChoiceFieldFragment;

export function Edit({ id, label }: Props) {
    const form = useForm();

    const defaultPackage = 'SQUARESPACE_WEB_ESSENTIAL_V1';

    if (!form.get(id)) {
        form.set(id, defaultPackage);
    }

    const { onChange } = form.attach(id, true);

    const { webPackages, webPackagesError, loading } = useWebPackageConfig();

    if (webPackagesError) {
        throw webPackagesError;
    }

    return (
        <>
            <Stack space="1.5bu">
                <SectionHeading>{label}</SectionHeading>
                {loading ? (
                    <Box display={'flex'} justifyContent={'center'}>
                        <Spinner />
                    </Box>
                ) : (
                    webPackages.map((item) => {
                        return (
                            <PackageCard
                                key={item.id}
                                id={item.id}
                                title={item.title}
                                description={item.description}
                                price={item.price}
                                content={item.content}
                                isSelected={item.id === form.get(id)}
                                onSelection={(value: string) => onChange(value)}
                                logo={item.logo}
                                featureColor={item.featureColor}
                                features={item.features}
                            />
                        );
                    })
                )}
            </Stack>
            <Box marginBottom="3bu" />
        </>
    );
}

export function View({ squarespacePackageChoiceValue }: Props) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{squarespacePackageChoiceValue}</>;
}

export function HasValue({ squarespacePackageChoiceValue }: Props): boolean {
    return squarespacePackageChoiceValue !== '';
}

export function getValue({ squarespacePackageChoiceValue }: Props) {
    return squarespacePackageChoiceValue;
}
